import React from "react";

function About() {
  return (
    <main className="pt-24 max-w-5xl mx-auto px-6">
      <h2 className="text-4xl font-bold text-brand-red mb-6">About Us</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-12">
        Welcome to Texana Trading Co., where quality, style, and Texas charm come together. Each piece in our collection is carefully selected for its character, durability, and authentic rustic appeal — the kind that brings warmth and personality into any space.

        We specialize in custom made furniture, including dining tables, pub tables, chairs, barstools, consoles, and more. To make your piece truly your own, we offer full customization options, allowing you to choose the stain, finish, and leather that best fit your home and lifestyle.

        Our mission is to provide exceptional customer service and high quality furniture that captures the spirit of Texas living.

        Thank you for visiting our website and supporting local businesses in West Texas. We look forward to helping you bring a drop of Texas into your life.

      </p>

      {/* Bigger Logo with Fade-in */}
      <div className="flex justify-center mt-20">
        <img
          src="/logo.png"
          alt="Texana Trading Co."
          className="h-64 w-auto animate-fadeIn"
        />
      </div>
    </main>
  );
}

export default About;